var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1687 1.83203C10.9409 1.83203 11.5768 2.41552 11.6596 3.16566L12.5048 3.16536C13.1169 3.16536 13.6189 3.63677 13.6676 4.23635L13.6714 4.33203V6.33203C13.6714 7.48739 12.7671 8.43153 11.6277 8.49527L11.4875 8.49919C11.0423 9.89265 9.82191 10.9397 8.33348 11.1332L8.33307 12.1654H9.50206C10.6574 12.1654 11.6016 13.0697 11.6653 14.2091L11.6687 14.332V14.6654C11.6687 14.9185 11.4806 15.1277 11.2366 15.1608L11.1687 15.1654H4.50005C4.24692 15.1654 4.03772 14.9773 4.00461 14.7332L4.00005 14.6654V14.332C4.00005 13.1767 4.90435 12.2325 6.04377 12.1688L6.16671 12.1654H7.33307L7.3333 11.1329C5.84577 10.9388 4.62626 9.89203 4.18124 8.49919L4.16374 8.4987C2.96712 8.4987 1.99707 7.52865 1.99707 6.33203V4.33203C1.99707 3.6877 2.5194 3.16536 3.16374 3.16536L4.00917 3.16566C4.09194 2.41552 4.72785 1.83203 5.50005 1.83203H10.1687ZM12.5048 4.16536H11.6687V7.48727C12.2021 7.41225 12.6197 6.97658 12.667 6.4348L12.6714 6.33203V4.33203C12.6714 4.25313 12.6166 4.18704 12.543 4.16977L12.5048 4.16536ZM4.00005 4.16536H3.16374C3.07169 4.16536 2.99707 4.23998 2.99707 4.33203V6.33203C2.99707 6.92081 3.43321 7.40772 4.00005 7.48731V4.16536Z",
    fill: "#4B4AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.93dc02fc8933ac805cbc9b37d1586735.svg";
export { ForwardRef as ReactComponent };